import { render, staticRenderFns } from "./CollapsiblePanelComponent.vue?vue&type=template&id=fb7fd8d6"
import script from "./CollapsiblePanelComponent.vue?vue&type=script&lang=js"
export * from "./CollapsiblePanelComponent.vue?vue&type=script&lang=js"
import style0 from "./CollapsiblePanelComponent.vue?vue&type=style&index=0&id=fb7fd8d6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports